"use client";

/**
 * AuthCTA — клиентская замена серверному паттерну:
 *   <TrackedCTA href={isLoggedIn ? loggedInHref : guestHref}>
 *     {isLoggedIn ? "Открыть" : "Зарегистрироваться"}
 *   </TrackedCTA>
 *
 * Читает статус авторизации из UserSessionProvider (уже загружен в layout).
 * Позволяет страницам не вызывать auth() на сервере → можно использовать ISR.
 */

import React from "react";
import { useTranslations } from "next-intl";
import { TrackedCTA } from "@/components/analytics/TrackedCTA";
import { useUserSession } from "@/components/providers/UserSessionProvider";
import type { EventProps } from "@/lib/marketing/events";

interface Props {
  /** Href для авторизованного пользователя */
  loggedInHref: string;
  /** Href для гостя */
  guestHref: string;
  eventName: string;
  eventProps?: EventProps;
  /** Контент кнопки для гостя (опционально; по умолчанию — перевод cta.guest) */
  children?: React.ReactNode;
  /** Контент кнопки для залогиненного (если отличается от children) */
  loggedInChildren?: React.ReactNode;
  className?: string;
}

export function AuthCTA({
  loggedInHref,
  guestHref,
  eventName,
  eventProps,
  children,
  loggedInChildren,
  className,
}: Props) {
  const t = useTranslations("authCta");
  const { isLoggedIn } = useUserSession();
  const href = isLoggedIn ? loggedInHref : guestHref;
  const content = isLoggedIn
    ? (loggedInChildren ?? children ?? t("cta.member"))
    : (children ?? t("cta.guest"));

  return (
    <TrackedCTA
      href={href}
      eventName={eventName}
      eventProps={{ ...eventProps, logged_in: isLoggedIn }}
      className={className}
    >
      {content}
    </TrackedCTA>
  );
}
